import app from './app';
import contractGenerator from './contractGenerator';
import viatoUi from './viatoUi';

const resources = {
	en: {
		viatoUi: { ...viatoUi.en },
		app: { ...app.en },
		contractGenerator: { ...contractGenerator.en }
	},
	de: {
		viatoUi: { ...viatoUi.de },
		app: { ...app.de },
		contractGenerator: { ...contractGenerator.de }
	}
};

export default resources;
